import { render } from "./TranscriptionBotWizard.vue?vue&type=template&id=44d12533&scoped=true"
import script from "./TranscriptionBotWizard.vue?vue&type=script&lang=js"
export * from "./TranscriptionBotWizard.vue?vue&type=script&lang=js"

import "./TranscriptionBotWizard.vue?vue&type=style&index=0&id=44d12533&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44d12533"

export default script